function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styles from './InstrumentSelectModal.module.scss';

// third-party libs
import { Link } from 'react-router-dom';
import uriTemplates from 'uri-templates';

// language
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import en from './locales/InstrumentSelectModal.en.json';

// components
import Modal from '../Modal/Modal/Modal';
import ModalBody from '../Modal/ModalBody/ModalBody';
import H from '../H/H';
import I18n from '../I18n/I18n/I18n';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
function InstrumentLinkList(_ref) {
  var instruments = _ref.instruments,
    template = _ref.template,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles['instruments']
  }, instruments.map(function (instrument) {
    return /*#__PURE__*/React.createElement("li", {
      key: instrument.instrumentId,
      className: styles['instruments__instrument']
    }, /*#__PURE__*/React.createElement(Link, {
      to: uriTemplates(template).fill(_objectSpread({}, context || {}, {
        instrumentId: String(instrument.instrumentId)
      }))
    }, instrument.name));
  }));
}
export default function InstrumentSelectModal(_ref2) {
  var instruments = _ref2.instruments,
    location = _ref2.location;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: normalizeLocaleData(en, '@dm/components.instrument-select-modal'),
    path: "InstrumentSelectModal/locales/InstrumentSelectModal",
    namespace: "@dm/components.instrument-select-modal"
  }, /*#__PURE__*/React.createElement(Modal, {
    alert: true,
    escapeExits: false,
    mounted: true,
    includeCloseX: false,
    titleText: "@dm/components.instrument-select-modal.select-instrument"
  }, /*#__PURE__*/React.createElement(ModalBody, {
    alignment: "left"
  }, /*#__PURE__*/React.createElement(H, {
    className: styles['instruments-modal-title']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.instrument-select-modal.select-instrument"
  })), location && /*#__PURE__*/React.createElement(InstrumentLinkList, Object.assign({
    instruments: instruments
  }, location)))));
}